import * as React from 'react';
import { useSelector } from 'react-redux';

import { ResultsEmpty, trackSearchOffersButtonClick, trackSignInButtonClick } from '../../components/ResultsEmpty';
import { ResultsEmptyFolder } from '../../components/ResultsEmpty/ResultsEmptyFolder';
import { selectFilters } from '../../selectors/filters';
import { selectSelectedFolder } from '../../selectors/folders';
import { selectPage } from '../../selectors/page';
import { selectResults } from '../../selectors/results';
import { selectUser } from '../../selectors/user';
import { EGetFavoriteEntitiesStatus } from '../../types/results';
import { getSearchUrl } from '../../utils/filters';
import { EEntityType } from '../../types/filters';
import { ResultsEmptyNewbuilding } from '../../components/ResultsEmpty/ResultsEmptyNewbuilding';
import { EDeviceType } from '../../types/device';
import { ResultsEmptyV2 } from '../../components/ResultsEmptyV2';

interface IResultsEmptyContainerProps {
  isExperimentEnabled?: boolean;
}

export function ResultsEmptyContainer({ isExperimentEnabled }: IResultsEmptyContainerProps) {
  const user = useSelector(selectUser);
  const results = useSelector(selectResults);
  const filters = useSelector(selectFilters);
  const page = useSelector(selectPage);
  const selectedFolder = useSelector(selectSelectedFolder);

  const { status } = results;
  const { deviceType } = page;
  const { isAuthenticated } = user;

  const handleClickSearch = () => {
    if (isAuthenticated) {
      trackSearchOffersButtonClick();
      window.location.assign(selectedFolder ? '/' : getSearchUrl(filters));
    } else {
      trackSignInButtonClick();
      if (window.hasOwnProperty('waitForLoginPopup')) {
        window.waitForLoginPopup();
      }
    }
  };

  if (status === EGetFavoriteEntitiesStatus.Failed) {
    return null;
  }

  if (selectedFolder) {
    return (
      <ResultsEmptyFolder isAuthenticated={isAuthenticated} onClickSearch={handleClickSearch} deviceType={deviceType} />
    );
  }

  if (filters.favoriteEntityType === EEntityType.Newbuilding) {
    return <ResultsEmptyNewbuilding user={user} filters={filters} deviceType={deviceType} />;
  }

  if (deviceType === EDeviceType.Desktop) {
    return <ResultsEmpty user={user} filters={filters} size="M" />;
  }

  if (isExperimentEnabled && user.isAuthenticated) {
    return <ResultsEmptyV2 user={user} />;
  }

  return <ResultsEmpty user={user} filters={filters} size="XS" />;
}
